export const aboutTranslations = {
  de: {
    title: 'Über uns',
    text1: 'Autoteile Flott steht für persönliche Beratung und Fachwissen aus jahrelanger Erfahrung. Wir helfen Ihnen, das exakt passende Autoteil zu finden – garantiert. Statt riskanter Online-Bestellungen erhalten Sie bei uns geprüfte Qualität, individuelle Beratung und die Sicherheit, dass alles passt.',
    text2: 'Innerhalb von 24 Stunden ist Ihr bestelltes Teil abholbereit – zuverlässig und unkompliziert.',
    feature1Title: '100% Passgenau',
    feature1Text: 'Garantiert das richtige Teil für Ihr Fahrzeug',
    feature2Title: '24h Bereitstellung',
    feature2Text: 'Schnelle Lieferung und Abholbereitschaft',
    feature3Title: 'Persönliche Beratung',
    feature3Text: 'Fachwissen aus jahrelanger Erfahrung'
  },
  en: {
    title: 'About Us',
    text1: 'Autoteile Flott stands for personal consulting and expertise from years of experience. We help you find the exactly matching auto part – guaranteed. Instead of risky online orders, you receive verified quality, individual consulting, and the security that everything fits.',
    text2: 'Within 24 hours, your ordered part is ready for pickup – reliable and uncomplicated.',
    feature1Title: '100% Perfect Fit',
    feature1Text: 'Guaranteed the right part for your vehicle',
    feature2Title: '24h Availability',
    feature2Text: 'Fast delivery and pickup readiness',
    feature3Title: 'Personal Consultation',
    feature3Text: 'Expertise from years of experience'
  },
  hu: {
    title: 'Rólunk',
    text1: 'Az Autoteile Flott a személyes tanácsadást és az évek tapasztalatából származó szakértelmet képviseli. Segítünk megtalálni a pontosan illeszkedő autóalkatrészt – garantáltan. Kockázatos online rendelések helyett ellenőrzött minőséget, egyéni tanácsadást és azt a biztonságot kapja, hogy minden passzol.',
    text2: '24 órán belül a megrendelt alkatrész átvehető – megbízhatóan és bonyolultság nélkül.',
    feature1Title: '100% Pontos Illeszkedés',
    feature1Text: 'Garantáltan a megfelelő alkatrész járművéhez',
    feature2Title: '24 órás Rendelkezésre állás',
    feature2Text: 'Gyors szállítás és átvételi készenlét',
    feature3Title: 'Személyes Tanácsadás',
    feature3Text: 'Évek tapasztalatából származó szakértelem'
  },
  pl: {
    title: 'O nas',
    text1: 'Autoteile Flott oznacza osobiste doradztwo i wiedzę fachową z wieloletniego doświadczenia. Pomożemy Ci znaleźć dokładnie pasującą część samochodową – gwarantowane. Zamiast ryzykownych zamówień online, otrzymujesz sprawdzoną jakość, indywidualne doradztwo i pewność, że wszystko pasuje.',
    text2: 'W ciągu 24 godzin zamówiona część jest gotowa do odbioru – niezawodnie i bez komplikacji.',
    feature1Title: '100% Idealne Dopasowanie',
    feature1Text: 'Gwarantowana odpowiednia część do pojazdu',
    feature2Title: '24h Dostępność',
    feature2Text: 'Szybka dostawa i gotowość odbioru',
    feature3Title: 'Osobiste Doradztwo',
    feature3Text: 'Wiedza fachowa z wieloletniego doświadczenia'
  }
};
